<!--设置宿舍的设备码-->
<template>
  <div>
    <!--    新电表 start -->
    <el-form v-if="parentData.electricType===2" ref="form" v-loading="loading" :model="electricFormData" :rules="rules"
             label-width="140px"
             style="margin-top: 40px;">
      <el-form-item label="电表码(新电表)" prop="regionId">
        <div class="flex">
          <tool-tips-group is-flex
                           tips-content="设置了电表码（新版电表）后，再打开本弹窗，会显示宿舍的设置记录、赠送记录等">
            <el-input v-model.trim="electricFormData.meterNumber" class="flex-1" maxlength="100" />
          </tool-tips-group>
          <el-button type="primary" @click="setMeterNum">绑定电表码</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!--    新电表 end -->
    <!--    旧电表 or 旧水表 start -->
    <el-form v-if="parentData.waterType===1 ||parentData.electricType===1" ref="form" v-loading="loading"
             :model="formData" :rules="rules" label-width="140px"
             style="margin-top: 40px;">
      <el-row v-if="parentData.electricType===1">
        <el-col :span="20">
          <el-form-item label="房间号(厂家标识)" prop="regionId">
            <tool-tips-group is-flex
                             tips-content="设置了房间号 跟 电表设备ID（掌控电表）后，再打开本弹窗，会显示宿舍的设置记录、赠送记录等">
              <el-input v-model.trim="formData.regionId" />
            </tool-tips-group>
          </el-form-item>
          <el-form-item label="电表设备ID(掌控)" prop="electricDeviceId">
            <tool-tips-group is-flex
                             tips-content="设置了房间号 跟 电表设备ID后，再打开本弹窗，会显示宿舍的设置记录、赠送记录等">
              <el-input v-model.trim="formData.electricDeviceId" maxlength="100" />
            </tool-tips-group>
          </el-form-item>
        </el-col>
        <el-col v-if="parentData.waterType===2" :span="4" style="padding-top: 40px;">
          <el-button class="ml-1" type="primary" @click="save('电表信息', addDormRoom, '电表(掌控)信息更新成功！')">绑定电表码</el-button>
        </el-col>
      </el-row>
      <el-row v-if="parentData.waterType===1">
        <el-col :span="20">
          <!--    旧水表  -->
          <el-form-item label="水表设备ID(掌控)" prop="waterDeviceId">
            <el-input v-model.trim="formData.waterDeviceId" maxlength="100" />
          </el-form-item>
          <el-form-item label="水表设备码(掌控)" prop="waterSerialNo">
            <el-input v-model.trim="formData.waterSerialNo" maxlength="100" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  电表类型=2时才显示此按钮 -->
          <div v-if="parentData.electricType===2" class="font-center">
            <el-button class="ml-1" type="primary" @click="save('电表信息', addDormRoom, '水表(掌控)信息更新成功！')">绑定水表码</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--    旧电表 or 旧水表 end -->
    <!--    新水表 start -->
    <el-form v-if="parentData.waterType===2" ref="form" v-loading="loading" :model="waterFormData" :rules="rules"
             label-width="140px"
             style="margin-top: 40px;">
      <el-form-item :label="`水表码(${parentData.waterType===2?'新':'掌控'})`"
                    prop="deviceId">
        <div class="flex">
          <el-input v-model.trim="waterFormData.deviceId" class="flex-1" maxlength="100" />
          <el-button class="ml-1" type="primary" @click="setWaterMeterNum">绑定水表码</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!--    新水表 end -->
  </div>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import { copyData } from '@/utils/common-js'
import {
  setNewElectricMeterApi
} from '@/api/dorm/set-electric-meter-api'
import { bindNewWaterMeterApi } from '@/api/logistics/water-meter-api'
import { addDormRoom } from '@/api/dorm'

export default {
  name: 'setDormDeviceIdForm',
  mixins: [dialog],
  props: {
    parentData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      formData: { // 宿舍信息
        id: null,
        electricDeviceId: '',
        regionId: '',
        waterDeviceId: '',
        waterSerialNo: '',
        meterNumber: null,
        startUpFlag: null,
        electricType: null,
        waterType: null,
        collegeId: this.$store.state.login.userInfo.collegeId || ''
      },
      // 新水表
      waterFormData: {
        deviceId: '', // newWaterDeviceId 水表设备码 ;newWaterId 水表id(暂时无用)
        dormitoryRoomId: ''
      },
      // 新电表
      electricFormData: {
        deviceId: '', //
        dormitoryRoomId: ''
      },
      rules: {
        regionId: [
          {
            message: '请填写房间号',
            trigger: 'blur'
          },
          {
            max: 200,
            message: '仅限200字',
            trigger: 'blur'
          }
        ],
        deviceId: [
          {
            message: '请填写水表码',
            trigger: 'blur'
          },
          {
            max: 200,
            message: '仅限200字',
            trigger: 'blur'
          }
        ],
        electricDeviceId: [
          {
            message: '请填写电表设备ID',
            trigger: 'blur'
          },
          {
            max: 200,
            message: '仅限200字',
            trigger: 'blur'
          }
        ],
        waterDeviceId: [
          {
            message: '请填写水表设备ID',
            trigger: 'blur'
          },
          {
            max: 200,
            message: '仅限200字',
            trigger: 'blur'
          }
        ],
        waterSerialNo: [
          {
            message: '请填写水表设备码',
            trigger: 'blur'
          },
          {
            max: 200,
            message: '仅限200字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  async mounted() {
    await this.$nextTick()
    if (this.parentData) {
      if (this.parentData.electricType === 1 && this.parentData.waterType === 1) {
        //   旧电表 + 旧水表
        copyData(this.parentData, this.formData)
      } else if (this.parentData.electricType === 1 && this.parentData.waterType === 2) {
        // 旧电表 + 新水表
        this.waterFormData = {
          dormitoryRoomId: this.parentData.id,
          deviceId: this.parentData.newWaterDeviceId
        }
        copyData(this.parentData, this.formData)
      } else if (this.parentData.waterType === 1 && this.parentData.electricType === 2) {
        // 新电表 + 旧水表
        this.electricFormData = {
          dormitoryRoomId: this.parentData.id,
          meterNumber: this.parentData.meterNumber
        }
        copyData(this.parentData, this.formData)
      } else {
        // 新电表 + 新水表
        this.electricFormData = {
          dormitoryRoomId: this.parentData.id,
          meterNumber: this.parentData.meterNumber
        }
        this.waterFormData = {
          dormitoryRoomId: this.parentData.id,
          deviceId: this.parentData.newWaterDeviceId
        }
      }
    }
  },
  methods: {
    addDormRoom,
    setNewElectricMeterApi,
    setMeterNum() {
      this.$confirm('点击“确定”保存电表码。', '提示').then(async () => {
        try {
          this.loading = true
          await setNewElectricMeterApi(this.electricFormData)
          this.$message.success('保存成功')
        } catch (e) {
          console.error(e)
        } finally {
          this.loading = false
        }
      })
    },
    // 设置水表码
    setWaterMeterNum() {
      this.$confirm('点击“确定”保存水表码。', '提示').then(async () => {
        try {
          this.loading = true
          await bindNewWaterMeterApi(this.waterFormData)
          this.$message.success('保存成功')
        } catch (e) {
          console.error(e)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
